import { atom } from 'recoil';

export const solvedAtom = atom({
  key: 'solvedState',
  default: false
});
